import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import WarningAmberIcon from "@material-ui/icons/WarningAmber";

type NoDataIndicatorProps = {
  message?: string;
  icon?: React.ReactNode;
};

const NoDataIndicator: FC<NoDataIndicatorProps> = ({
  message = "No Data Available",
  icon = <WarningAmberIcon color="disabled" fontSize="large" />,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height='100%'
      justifyContent="center"
      py={4}
      color="text.secondary"
    >
      <Box mb={1}>{icon}</Box>
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

export default NoDataIndicator;
